import { render, staticRenderFns } from "./Q1.vue?vue&type=template&id=f79ae12a&"
import script from "./Q1.vue?vue&type=script&lang=js&"
export * from "./Q1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports